export default __webpack_public_path__ + "static/media/header-blumen.f0731885.png";